// Escala de calificaciones (Módulo 9).
//
// Requerimiento cliente:
//   - Renombrar "Fallo" -> "Nota" en toda la UI (UI textual ya unificada).
//   - Escala numérica 0 a 12:
//       * 0 - 3  -> NO APROBADO         -> el alumno RECURSA.
//       * 4 - 8  -> APROBADO            -> debe RENDIR EXAMEN.
//       * 9 - 12 -> APROBADO + EXONERADO-> NO rinde examen.
//
// Reglas complementarias:
//   - "Curso aprobado" (sin exonerar) NO tiene nota asociada en el acta
//     del dictado: simplemente queda como aprobado. La nota se asigna
//     recién en el examen.
//   - "Exonerado" SÍ persiste la nota como si fuera examen (se guarda
//     en la tabla de exam grades con marca "exonerated = true") para
//     que aparezca en la historia académica.
//
// Resultado final por inscripción (Módulo 11 - reglas críticas):
//   - "No aprobado" en el dictado -> resultado final "NO Aprobado" (recursa).
//   - "Aprobado"                  -> pendiente de examen.
//   - "Exonerado"                 -> aprobado definitivo, sin examen.

export const GRADE_MIN = 0;
export const GRADE_MAX = 12;

export const GRADE_RESULTS = {
  NO_APROBADO: 'no_aprobado',
  APROBADO: 'aprobado',
  EXONERADO: 'exonerado',
};

export const GRADE_RESULT_LABELS = {
  [GRADE_RESULTS.NO_APROBADO]: 'No aprobado',
  [GRADE_RESULTS.APROBADO]: 'Aprobado',
  [GRADE_RESULTS.EXONERADO]: 'Exonerado',
};

/**
 * Dada una nota numérica (0-12) devuelve el resultado según la escala.
 * Devuelve null si la nota está fuera de rango o no es numérica.
 */
export function inferResultFromGrade(grade) {
  if (grade === '' || grade === null || grade === undefined) return null;
  const n = Number(grade);
  if (Number.isNaN(n)) return null;
  if (n < GRADE_MIN || n > GRADE_MAX) return null;
  if (n <= 3) return GRADE_RESULTS.NO_APROBADO;
  if (n <= 8) return GRADE_RESULTS.APROBADO;
  return GRADE_RESULTS.EXONERADO;
}

/**
 * Valida que una nota esté dentro de la escala 0-12.
 */
export function isValidGrade(grade) {
  const n = Number(grade);
  return !Number.isNaN(n) && n >= GRADE_MIN && n <= GRADE_MAX;
}

/**
 * Determina si el resultado del DICTADO requiere persistir nota en el acta.
 *   - "aprobado" (no exonerado): NO guarda nota en el dictado.
 *   - "no_aprobado": guarda nota (para ver la insuficiencia).
 *   - "exonerado":   guarda nota (se replica como examen).
 */
export function shouldPersistGradeInDictatedActa(result) {
  return (
    result === GRADE_RESULTS.NO_APROBADO ||
    result === GRADE_RESULTS.EXONERADO
  );
}

/**
 * Resultado final de la inscripción a la materia.
 * - no_aprobado -> "NO Aprobado" (final, recursa).
 * - aprobado    -> "Aprobado (pendiente de examen)".
 * - exonerado   -> "Aprobado (exonerado)".
 */
export function getFinalInscriptionResult(dictatedResult) {
  switch (dictatedResult) {
    case GRADE_RESULTS.NO_APROBADO:
      return 'NO Aprobado';
    case GRADE_RESULTS.APROBADO:
      return 'Aprobado (pendiente de examen)';
    case GRADE_RESULTS.EXONERADO:
      return 'Aprobado (exonerado)';
    default:
      return 'Pendiente';
  }
}
